import './App.css';

import {
  BrowserRouter,
  Link,
  Route,
  Routes,
} from 'react-router-dom';

import Services from './components/Services/Services';
import AboutUs from './components/AboutUs/AboutUs';
import OurTeam from './components/OurTeam/OurTeam';
import Products from './components/Products/Products';
import ContactUs from './components/ContactUs/ContactUs';
import Home from './components/Home/Home';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <header className="App-header">
          <div className="navbar-container">
            <div className="logo">
              <Link to="/" aria-label="Quantechs home">
                <img
                  src="/images/logo.png"
                  alt="Quantechs Services"
                />
              </Link>
            </div>

            <nav className="navbar" aria-label="Main navigation">
              <ul>
                <li>
                  <Link to="/Services">Our Services</Link>
                </li>
                <li>
                  <Link to="/AboutUs">About Us</Link>
                </li>
              </ul>
            </nav>
          </div>
        </header>

        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/AboutUs" element={<AboutUs />} />
            <Route path="/OurTeam" element={<OurTeam />} />
            <Route path="/Products" element={<Products />} />
            <Route path="/ContactUs" element={<ContactUs />} />
          </Routes>
        </main>

        <footer className="site-footer">
          <div className="footer">
            <div className="footer-content">
              <h2 className="footer-title">Contact Us</h2>

              <div className="footer-main">
                <div className="footer-contact-list">
                  <div className="footer-contact-item footer-address">
                    <img
                      className="footer-contact-icon"
                      alt="Office location"
                      src="/images/icon3.png"
                    />
                    <address>
                      6/1 Galpotta Road,
                      <br />
                      Nawala,
                      <br />
                      Sri Jayardenepura Kotte,
                      <br />
                      Sri Lanka
                    </address>
                  </div>

                  <div className="footer-contact-item">
                    <img
                      className="footer-contact-icon"
                      alt="Telephone"
                      src="/images/icon2.png"
                    />
                    <a href="tel:+94112805307">+94 112 805 307</a>
                  </div>

                  <div className="footer-contact-item">
                    <img
                      className="footer-contact-icon"
                      alt="Email"
                      src="/images/icon1.png"
                    />
                    <a href="mailto:info@quantechs.com">
                      info@quantechs.com
                    </a>
                  </div>
                </div>

                <div className="footer-social" aria-label="Social media links">
                  <a
                    href="https://www.linkedin.com/company/quantechs/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Quantechs LinkedIn"
                  >
                    <img alt="LinkedIn" src="/images/sm2.png" />
                  </a>

                  <a
                    href="https://web.facebook.com/Quantechs"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Quantechs Facebook"
                  >
                    <img alt="Facebook" src="/images/sm1.png" />
                  </a>
                </div>
              </div>

              <div className="footer-copyright">
                © Copyright 2026 by Quantechs Services. All Rights Reserved.
              </div>
            </div>
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
